
import MainView from '../views/mainView.vue'

 const router= [
    {
        path: '/',
        component: MainView
      }
    ]
export default router



// WEBPACK FOOTER //
// ./src/pages/COECOACHInfo/routers/router.js